
<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Repositories from '@/repositories';
const WorkOrdersRepository = Repositories.get('workorders');
import { required, minLength } from 'vuelidate/lib/validators';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/fr';
import 'vue-loading-overlay/dist/vue-loading.css';
import Tooltip from '@/components/widgets/errors/validations-tooltip.vue';

export default {
  components: {
    Loading,
    Tooltip,
    DatePicker,
  },
  props: {
    modalId: { type: String, default: 'create-work-order-modal' },
  },
  data() {
    return {
      isLoading: false,
      formObject: {
        name: '',
        deliveryDate: new Date().toISOString().slice(0, 10),
        installationDate: new Date().toISOString().slice(0, 10),
        productionDate: new Date().toISOString().slice(0, 10),
      },
    };
  },
  methods: {
    modalHidden() {
      this.$emit('modal-closed');
    },
    modalShown() {
      this.isLoading = false;
      this.formObject = {
        name: '',
        deliveryDate: new Date().toISOString().slice(0, 10),
        installationDate: new Date().toISOString().slice(0, 10),
        productionDate: new Date().toISOString().slice(0, 10),
      };
    },
    async createWorkOrder() {
      this.isLoading = true;

      try {
        let resp = await WorkOrdersRepository.create(this.formObject);

        this.$toast.successToast(this.$t('general.success'));

        this.$router.push({
          name: 'manageWorkOrder',
          params: { idPublic: resp.data.idPublic },
        });
      } catch (error) {
        this.$toast.errorToast(this.$t('errors.errorLoading'));
      } finally {
        this.isLoading = false;
      }
    },
    onSubmit() {
      this.$v.formObject.$touch();
      if (!this.$v.formObject.$invalid) {
        this.isLoading = true;
        this.createWorkOrder();
      }
    },
  },
  validations() {
    return {
      formObject: {
        name: { required, minLength: minLength(1) },
        deliveryDate: { required },
        installationDate: { required },
        productionDate: { required },
      },
    };
  },
};
</script>

<template>
  <div>
    <b-modal
      :id="modalId"
      scrollable
      size="lg"
      :title="$t('general.create')"
      @shown="modalShown()"
      @hide="modalHidden()"
      ok-variant="success"
    >
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        color="#f1b44c"
        :width="70"
        :height="70"
        loader="dots"
        :is-full-page="false"
      >
      </loading>

      <div class="container">
        <b-form @submit.prevent="onSubmit">
          <b-form-group
            id="input-group-name"
            :label="$t('general.name')"
            label-for="input-name"
          >
            <b-form-input
              id="input-name"
              :class="{
                'is-invalid': $v.formObject.name.$error,
              }"
              v-model="formObject.name"
              type="text"
              :placeholder="$t('general.name')"
            ></b-form-input>
            <Tooltip :validations="$v.formObject.name" />
          </b-form-group>
        </b-form>

        <b-form-group
          id="input-group-delivery-date"
          :label="$t('general.deliveryDate')"
          label-for="input-delivery-date"
        >
          <DatePicker
            id="input-delivery-date"
            v-model="formObject.deliveryDate"
            :first-day-of-week="1"
            format="YYYY-MM-DD"
            value-type="format"
            :lang="$i18n.locale"
          >
          </DatePicker>
        </b-form-group>

        <b-form-group
          id="input-group-installation-date"
          :label="$t('general.installationDate')"
          label-for="input-installation-date"
        >
          <DatePicker
            id="input-installation-date"
            v-model="formObject.installationDate"
            :first-day-of-week="1"
            format="YYYY-MM-DD"
            value-type="format"
            lang="en"
          >
          </DatePicker>
        </b-form-group>

        <b-form-group
          id="input-group-production-date"
          :label="$t('general.productionDate')"
          label-for="input-production-date"
        >
          <DatePicker
            id="input-production-date"
            v-model="formObject.productionDate"
            :first-day-of-week="1"
            format="YYYY-MM-DD"
            value-type="format"
            lang="en"
          >
          </DatePicker>
        </b-form-group>
      </div>

      <template #modal-footer>
        <b-button @click="$bvModal.hide(modalId)" size="sm" variant="danger">
          {{ $t('general.cancel') }}
        </b-button>
        <b-button @click="onSubmit" size="sm" variant="success">
          {{ $t('general.save') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>